import { z } from 'zod';
import type { GetWithStatisticsResponse } from '../types/GetWithStatisticsResponse';

export const getWithStatisticsResponseSchema = z.object({
  data: z.array(
    z.object({
      id: z.string().uuid(),
      title: z.string().min(3).max(255),
      description: z.string().min(3).max(255).nullable(),
      cover: z.string().nullable(),
      isActive: z.boolean().default(false).optional(),
      numberOfViews: z.number().int().min(0).default(0).optional(),
      numberOfReviews: z.number().int().min(0).default(0).optional(),
      numberOfThoseWhoCompleted: z.number(),
      rating: z.number().nullable(),
      numberOfCards: z.object({ active: z.number(), inactive: z.number() }),
    }),
  ),
  meta: z.object({
    page: z.number().int().min(1).default(1).optional(),
    take: z.number().int().min(1).default(10).optional(),
    numberOfItems: z.number().int(),
    numberOfPages: z.number().int(),
    hasPrevious: z.boolean(),
    hasNext: z.boolean(),
  }),
}) as z.ZodType<GetWithStatisticsResponse>;
